import ApiService from "./api.service";

const InspectionService = {
  GetList(data) {
    return ApiService.post(`/Inspection/GetList`, data);
  },
  SearchByDocNumber(docNumber) {
    return ApiService.get(
      `/Inspection/SearchByDocNumber?docNumber=${encodeURIComponent(docNumber)}`
    );
  },
  GetPersonFioByPinfl(pinfl) {
    return ApiService.get(
      `/Inspection/GetPersonFioByPinfl?pinfl=${encodeURIComponent(pinfl)}`
    );
  },
  SearchEmployeeByPinfl(pinfl, organizationId) {
    let url = `/Inspection/SearchEmployeeByPinfl?pinfl=${encodeURIComponent(
      pinfl
    )}`;
    if (organizationId) {
      url += `&organizationId=${organizationId}`;
    }
    return ApiService.get(url);
  },
  Get(id) {
    if (id == 0 || id == undefined || id == null || id == "") {
      return ApiService.get(`/Inspection/Get`);
    }
    return ApiService.get(`/Inspection/Get/${id}`);
  },
  Create(data) {
    return ApiService.post(`/Inspection/Create`, data);
  },
  Update(data) {
    return ApiService.post(`/Inspection/Update`, data);
  },
  Complete(data) {
    return ApiService.post(`/Inspection/Complete`, data);
  },
  UploadFile(file) {
    const fd = new FormData();
    fd.append("files", file);
    return ApiService.formData(`/Inspection/UploadFile`, fd);
  },
  DownloadFile(fileId) {
    return ApiService.print(`/Inspection/DownloadFile/${fileId}`);
  },
  DeleteFile(fileId) {
    return ApiService.post(`/Inspection/DeleteFile/${fileId}`);
  },
  GetSecurityInfo() {
    return ApiService.get(`/Inspection/GetSecurityInfo`);
  },
};

export default InspectionService;
